<template>
  <Link class="nav-logo" :href="url" :tracking="tracking" :aria-label="logoAriaLabel">
    <Picture
      :image-url="logoUrl"
      :using-scene7="false"
      :pt="{
        img: {
          fetchPriority: 'high',
          loading: 'eager',
        },
      }"
      :alt="`${isMcom ? 'macys' : 'bloomingdales'} logo`"
    />
  </Link>
</template>

<script setup>
import Picture from '@nuxt-common/atomic-ui/app/components/picture/Picture';
import { Links, logoLabel } from 'config';
import Link from './Link';
import getAssetImage from '~/utils/getAssetImage';

const { isMcom } = useEnvProps();
const logoAriaLabel = logoLabel.site;
const { tracking, url } = Links.homepage.site;
const logoUrl = getAssetImage('logo.svg');
</script>

<style lang="scss">
.nav-logo {
  display: block;
  position: relative;
  width: fit-content;

  picture {
    display: block;
    overflow: hidden;

    img {
      height: 100%;
      color: transparent;
    }
  }
}
</style>

<style lang="scss" brand="mcom">
.nav-logo {
  picture {
    width: 99px;
    height: 28px;
  }

  @include breakpoint(large up) {
    picture {
      width: 141px;
      height: 40px;
    }
  }
}
</style>

<style lang="scss" brand="bcom">
.nav-logo {
  picture {
    width: 155px;
    height: 24px;
  }

  @include breakpoint(large up) {
    top: 5px;

    picture {
      width: 263px;
      height: 40px;
    }
  }
}
</style>
